/** Fallback URL slugs when the categories API is unavailable (matches production seed). */
export const FALLBACK_CATEGORY_URL_SLUGS = new Set([
  'resumes',
  'tenancy-agreements',
  'lease-and-business-agreements',
  'organograms',
  'toolkits',
  'other',
]);

const FALLBACK_SLUG_TO_ID = {
  resumes: 'resume',
  'tenancy-agreements': 'tenancy-agreement',
  'lease-and-business-agreements': 'lease-business-agreement',
  organograms: 'organogram',
  toolkits: 'toolkit',
  other: 'other',
};

export function isCategoryUrlSlug(slug, categories, { allowFallback = true } = {}) {
  if (!slug) return false;
  if (categories?.length) {
    return categories.some((cat) => cat.url_slug === slug);
  }
  return allowFallback && FALLBACK_CATEGORY_URL_SLUGS.has(slug);
}

export function categorySlugToId(slug, categories) {
  if (!slug) return null;
  const match = categories?.find((cat) => cat.url_slug === slug);
  if (match) return match.id;
  return FALLBACK_SLUG_TO_ID[slug] ?? null;
}

export function categoryIdToPath(id, categories) {
  if (!id || id === 'all') return '/templates';
  const match = categories?.find((cat) => cat.id === id);
  return match?.url_slug ? `/templates/${match.url_slug}` : '/templates';
}

export function buildStoreNavItems(categories, products, { categoriesFailed = false } = {}) {
  const counts = products.reduce((acc, product) => {
    const key = product.subcategory || 'other';
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const source = categoriesFailed ? [] : (categories || []);

  const items = [
    { id: 'all', label: 'All', url_slug: null, count: products.length },
    ...source.map((cat) => ({
      id: cat.id,
      label: cat.name,
      url_slug: cat.url_slug,
      count: counts[cat.id] || 0,
    })),
  ];

  if (categoriesFailed) {
    return items.filter((item) => item.id === 'all');
  }
  return items.filter((item) => item.id === 'all' || item.id === 'other' || item.count > 0);
}
